import React, { useState, useEffect } from 'react';
import ArchiveGroupsTabs from './ArchiveGroupsTabs';

import { getGroupsArchiveInfo } from '../../../actions'
import { GroupsList } from '..';


const [YYYY, MM] = new Date().toISOString().split("-").slice(0,2).map(v=>+v);

const periodFinishArchive = MM < 9 ? YYYY -2 : YYYY -1;

const depth = 7;

// Периоды (учебные годы)
const archivePeriods = Array.from({length: depth}, (_, i) => ({value: `${periodFinishArchive - i}`, label: `${periodFinishArchive - i}-${periodFinishArchive - i + 1}`}));
 
  

const ParentComponent = ({ kg_id, onEditGroup, isKgHead, onActionSelect}) => {
  const [showArchive, setShowArchive] = useState(false);
  const [value, SetValue] = useState(archivePeriods[0].value);
  const [groups, setGroups] = useState([]);


  useEffect(()=>{
    async function api() {
      const info = await getGroupsArchiveInfo(kg_id, value);
      if(info && info.groups) setGroups(info.groups);
    }

    api();

  },[value])



  
  // Данные групп (пример)
  const archiveGroupsData = [
    {
      id: 'group_2024_1',
      number: '1',
      period: '2024',
      periodStart: '2024-09-01',
      periodEnd: '2025-05-31',
      educator: 'Іваненко О.П.',
      childrenCount: 25,
      children: [] // массив детей группы
    },
    {
      id: 'group_2024_2',
      number: '2',
      period: '2024',
      periodStart: '2024-09-01',
      periodEnd: '2025-05-31',
      educator: 'Петренко М.І.',
      childrenCount: 28,
      children: []
    },
    {
      id: 'group_2023_1',
      number: '1',
      period: '2023',
      periodStart: '2023-09-01',
      periodEnd: '2024-05-31',
      educator: 'Сидоренко Т.В.',
      childrenCount: 26,
      children: []
    }
    // ... другие группы
  ];

  const user_info = {
    token: 'your_token_here',
    // ... другие данные пользователя
  };

  const KinderGarten = {
    id: 'kg_123',
    name: 'ДНЗ №123',
    // ... другие данные садика
  };


  const onEditGroupArchive = (group_id)=>{
    const data = groups.find(g=>g._id == group_id);
    onEditGroup(data);
  }


  return (
    <div>
        <ArchiveGroupsTabs
          periods={archivePeriods}
          groupsData={archiveGroupsData}
          user_info={user_info}
          KinderGarten={KinderGarten}
          onCloseArchive={() => setShowArchive(false)}
          onChange={(value)=>SetValue(value)}
          isEmpty={ groups.length > 0}
        >
            <GroupsList 
              groups={ groups} 
              id={kg_id} 
              onEditGroup={onEditGroupArchive} 
              isKgHead={isKgHead} 
              onActionSelect={onActionSelect} 
              period={value} 
              isArchive={true}
              mode="view" 
              />
        </ArchiveGroupsTabs>
    </div>
  );
};

export default ParentComponent;